const TIMELINE_REMINDERS_URL = 'https://www.youtube.com/watch?v=LRO-edEUE0o'
const NORTHERN_SKY_RAID_TOOLS_URL =
  'https://www.curseforge.com/wow/addons/northern-sky-raid-tools'

const ExternalLink = ({ href, label }: { href: string; label: string }) => (
  <a
    href={href}
    target='_blank'
    rel='noopener noreferrer'
    className='text-primary hover:text-primary/90'
  >
    {label}
  </a>
)

export const TimelineRemindersLink = ({
  label = 'TimelineReminders',
}: {
  label?: string
}) => <ExternalLink href={TIMELINE_REMINDERS_URL} label={label} />

export const NorthernSkyRaidToolsLink = ({
  label = 'Northern Sky Raid Tools',
}: {
  label?: string
}) => <ExternalLink href={NORTHERN_SKY_RAID_TOOLS_URL} label={label} />
